// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__crMd9","iconMinHeight":"Layout_iconMinHeight__8SVb2"};